import { conditionalBranchMessage } from '../functions'

export default {
  function: {
    upload_common: {
      conditional_branch_message: (args: any) =>
        conditionalBranchMessage(args, (triggerQuestionSelectMetaList) => {
          if (triggerQuestionSelectMetaList.length === 1) {
            const { categoryName, questionDisplayNumber, selectText } = triggerQuestionSelectMetaList[0]
            return `Untuk yang menjawab '${selectText}' pada No. ${questionDisplayNumber} dari ${categoryName} (wajib).`
          }

          const messages = triggerQuestionSelectMetaList.map(
            ({ categoryName, questionDisplayNumber, selectText }) => {
              return `${selectText} pada No. ${questionDisplayNumber} dari ${categoryName} `
            }
          )
          return `Bagi yang menjawab ${messages.join(' atau ')} (Pertanyaan wajib)`
        }),
    },
    validation: {
      decimal_max_digit: 'Masukkan hingga {decimalMaxDigit} tempat desimal',
    },
  }
}
